<template>
  <button class="imagen-galeria">
    <img class="cover-img" :src="ruta_imgs" alt="tmp">
    <span class="titulo-anio">{{anio}}</span>
  </button>
</template>

<script>
export default {
  name: 'img-galeria',
  props: {
    ruta_imgs: String,
    anio:String,
  }
}
</script>

<style scoped lang="scss">
.imagen-galeria {
  width: 100%;
  overflow: hidden;
  aspect-ratio: 1;
  background: none;
  padding: 0;
  // border-radius: 0;
  border: 2px solid #fff;
  box-shadow: 0 4px 8px rgba(0,0,0,0);

  display: flex;
  flex-direction: column;
  color: black;

  img {
    box-sizing: border-box;
    border: 0 solid #505050;
    object-fit: cover;
    object-position: 50% 50%;
    opacity: 1;
    width: 100%;
    height: 100%;
  }
  &:hover,
  &:focus {
    box-shadow: 0 8px 16px rgba(0,0,0,.4);
  }

  span.titulo-anio{
    font-weight: 600;
    margin-top: .7em;
    font-size: 18px;
    margin-bottom: .2em;
  }
}
</style>
